import { Component, OnInit } from '@angular/core';
import { DataProviderService } from '../../service/data-provider.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.css']
})
export class SingleComponent implements OnInit {
  newsData: any;
  imageCount: Number;
  imageCount1: Number;
  imageCount2: Number;
  imageCount3: Number;
  News: any;
  constructor(private datapro: DataProviderService, public data: DataProviderService, public route: ActivatedRoute) {
    this.News = this.News = this.datapro.newSinglesample;
    let id = this.route.snapshot.paramMap.get('id');
    this.newsData = this.data.newSinglesample[id]
    if (this.newsData.hasOwnProperty('NewsArticlesCount')) {
      this.imageCount = Array.apply(null, { length: this.newsData.NewsArticlesCount }).map(Number.call, Number)
    }
    if (this.newsData.hasOwnProperty('NewsArticlesCount2')) {
      this.imageCount2 = Array.apply(null, { length: this.newsData.NewsArticlesCount2 }).map(Number.call, Number)
    }
    if (this.newsData.hasOwnProperty('NewsArticlesCount3')) {
      this.imageCount3 = Array.apply(null, { length: this.newsData.NewsArticlesCount3 }).map(Number.call, Number)
    }
    if (this.newsData.hasOwnProperty('EventPhotosCount')) {
      this.imageCount1 = Array.apply(null, { length: this.newsData.EventPhotosCount }).map(Number.call, Number)
    }

  }
  changeNews(i) {
    this.newsData = this.data.newSinglesample[parseInt(i)]
    if (this.newsData.hasOwnProperty('EventPhotosCount')) {
      this.imageCount1 = Array.apply(null, { length: this.newsData.EventPhotosCount }).map(Number.call, Number)
    }
    if (this.newsData.hasOwnProperty('NewsArticlesCount2')) {
      this.imageCount2 = Array.apply(null, { length: this.newsData.NewsArticlesCount2 }).map(Number.call, Number)
    }
    if (this.newsData.hasOwnProperty('NewsArticlesCount3')) {
      this.imageCount3 = Array.apply(null, { length: this.newsData.NewsArticlesCount3 }).map(Number.call, Number)
    }
    if (this.newsData.hasOwnProperty('NewsArticlesCount')) {
      this.imageCount = Array.apply(null, { length: this.newsData.NewsArticlesCount }).map(Number.call, Number)
    }
  }


  ngOnInit() {
    window.scrollTo(0, 0);
  }

}
